import { useState } from "react";
import { useTranslation } from "react-i18next";
import ArticleHeaderImage from '@/assets/agent-user-detail/article-header.webp'
import { Image } from "@/components/common/image";
import { HelpCircleIcon } from "./assets/icon/help-circle-icon";
import { TextInput } from "@/components/common/text-input";

interface ArticleHeaderProps {
  articleHeaderCopy: string;
  onChange: (key: string, value: string) => void;
}

export const ArticleHeader = ({ articleHeaderCopy, onChange }: ArticleHeaderProps) => {
  const { t } = useTranslation();
  const [hoverIcon, setHoverIcon] = useState(false);

  return (
    <div className="w-full h-full flex flex-col relative">
      <div className='relative flex items-center gap-1.5 text-base font-medium text-[rgba(0,0,0,1)] mb-5'>
        <span>{t("agent_dashboard.user_detail.article_header.title")}</span>
        <div
          className="max-w-max cursor-pointer"
          onMouseEnter={() => setHoverIcon(true)}
          onMouseLeave={() => setHoverIcon(false)}
        >
          <HelpCircleIcon className="w-5 h-5 text-[rgba(102,112,133,1)] hover:text-[rgba(52,64,84,1)]" />
        </div>
        {hoverIcon && (
          <div className="absolute p-1.5 w-[17.125rem] h-[10.063rem] top-8 -left-0 flex items-center justify-center z-[50] !bg-white bg-[rgba(0,0,0,0.05)] rounded-[12px] [box-shadow:0px_4.6px_9.1px_rgba(0,_0,_0,_0.2)] overflow-hidden" >
            <Image
              src={ArticleHeaderImage}
              alt={t("agent_dashboard.user_detail.article_header.title")}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
      <div className="min-w-[23.75rem] max-w-[23.75rem] ">
        <TextInput
          value={articleHeaderCopy || ''}
          placeholder={t("agent_dashboard.user_detail.article_header.placeholder")}
          className="h-11"
          onChange={(e) => onChange('articleHeaderCopy', e.target.value)}
          maxLength={15}
          showLength
        />
      </div>
    </div>
  )
}
